import { render } from "./MarketplaceApp.vue?vue&type=template&id=189ae086"
import script from "./MarketplaceApp.vue?vue&type=script&lang=js"
export * from "./MarketplaceApp.vue?vue&type=script&lang=js"

import "./MarketplaceApp.vue?vue&type=style&index=0&id=189ae086&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__